import React, { useState, useMemo, useEffect } from "react";
import { pdfjs, Document, Page } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { highlightPartialKeyword } from "../../../../components/HighlightKeyword";

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@5.2.133/build/pdf.worker.min.mjs`;

export default function PDFPreview({
  pdf,
  defaultPage = 1,
  query,
  onLoadSuccess,
  scale = 1.0,
}) {
  const [numPages, setNumPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(defaultPage);
  const [isDocumentReady, setIsDocumentReady] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);

  const options = useMemo(
    () => ({
      cMapUrl: "/cmaps/",
      standardFontDataUrl: "/standard_fonts/",
    }),
    []
  );

  // Convert base64 to Blob and create a URL
  useEffect(() => {
    if (!pdf) return;
    console.group("🔍 PDFPreview props");
    console.log("pdf (raw prop):", pdf);
    console.log("type:", typeof pdf);
    if (typeof pdf === "string") {
      console.log("  • length:", pdf.length);
      console.log("  • prefix:", pdf.slice(0, 30));
    }
    console.groupEnd();
    // const url = pdf.startsWith("data:")
    //   ? pdf
    //   : `data:application/pdf;base64,${pdf}`;
    setPdfUrl(pdf);
  }, [pdf]);

  useEffect(() => {
    setCurrentPage(defaultPage);
  }, [defaultPage]);

  const onDocumentLoadSuccess = ({ numPages: nextNumPages }) => {
    setNumPages(nextNumPages);
    setCurrentPage(Math.min(currentPage, nextNumPages));
    setIsDocumentReady(true);
    onLoadSuccess(nextNumPages);
  };

  return (
    <div className="Example">
      <div className="Example__container">
        <div className="Example__container__document">
          {pdfUrl && (
            <Document
              file={pdfUrl}
              onLoadSuccess={onDocumentLoadSuccess}
              options={options}
              onLoadError={(err) => console.error("PDF load error:", err)}
            >
              {numPages > 0 && isDocumentReady && (
                <Page
                  pageNumber={currentPage}
                  height={800}
                  scale={scale}
                  renderTextLayer={true}
                  customTextRenderer={({ str }) =>
                    highlightPartialKeyword(str, query)
                  }
                />
              )}
            </Document>
          )}
        </div>
      </div>
    </div>
  );
}
